export default __webpack_public_path__ + "static/logo-6601684826d93251d256cd6da09407c4.svg";